import React, { useState } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";

import { useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { RyderOrderHistory } from "./ryderOrderHistory";

export function EditIndividualRetailer() {
  const navigate = useNavigate();
  const [content, setContent] = useState(handlePersonalDetails());
  const [activeEdit, setactiveEdit] = useState("personal");
  function handleOrderHistory() {
    return(
      <RyderOrderHistory/>
    )
  }
  function handlePersonalDetails() {
    return (
      <div>
        <div className="editWholesaler-subcontainer">
          <div>
            <span className="edit-title">General Information</span>
          </div>
        </div>
        <div className="general-container">
          <div className="general-left">
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>Ryder Type
              </label>
              <div>
                {" "}
                <select className="editWholesaler-select">
                  <option>Select</option>
                </select>
              </div>
            </div>
         
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>Last Name
              </label>
              <div>
                <input type="text" placeholder="Enter Your Last Name" />
              </div>
            </div>

            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>Password
              </label>
              <div>
                <input type="text" placeholder="Enter Your Password" />
              </div>
            </div>
          </div>
          <div className="general-right">
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>First Name
              </label>
              <div>
                {" "}
                <input type="text" placeholder="Enter Your First Name" />
              </div>
            </div>
           
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>Email id
              </label>
              <div>
                {" "}
                <input type="text" placeholder="Enter Your Email id" />
              </div>
            </div>
          </div>
        </div>

        {/* address */}
        <div className="editWholesaler-subcontainer">
          <span className="edit-title">Address</span>
        </div>
        <div className="general-container">
          <div className="general-left">
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>Door No/House No
              </label>
              <div>
                {" "}
                <input
                  type="text"
                  placeholder="Enter Your Door  No/House No "
                />
              </div>
            </div>
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>Area/Locality
              </label>
              <div>
                {" "}
                <select className="editWholesaler-select">
                  <option>Select Area/Locality</option>
                </select>
              </div>
            </div>
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>City/Town
              </label>
              <div>
                {" "}
                <select className="editWholesaler-select">
                  <option>Select City/Town</option>
                </select>
              </div>
            </div>
          </div>
          <div className="general-right">
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>Street
              </label>
              <div>
                {" "}
                <input type="text" placeholder="Enter Your Street" />
              </div>
            </div>
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>State
              </label>
              <div>
                <select className="editWholesaler-select">
                  <option>Enter Your State</option>
                </select>
              </div>
            </div>
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>Pincode
              </label>
              <div>
                <input type="text" placeholder="Enter Your  Pincode" />
              </div>
            </div>
          </div>
        </div>
        {/* Bank Information  */}
        <div className="editWholesaler-subcontainer">
          <span className="edit-title">Bank Information</span>
        </div>
        <div className="general-container">
          <div className="general-left">
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>Account Number
              </label>

              <div>
                <input type="text" placeholder="Enter bank account number" />
              </div>
            </div>
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>Account Holder Name
              </label>

              <div>
                <input
                  type="text"
                  placeholder="Enter Account Holder Name "
                ></input>
              </div>
            </div>
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>Bank Name
              </label>

              <div>
                <input type="text" placeholder="Enter Bank Name "></input>
              </div>
            </div>
          </div>
          <div className="general-right">
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>Re-Enter Account Number
              </label>

              <div>
                <input
                  type="text"
                  placeholder="Re-Enter bank account number"
                ></input>
              </div>
            </div>
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>IFSC Code
              </label>

              <div>
                <input type="text" placeholder="Enter IFSC Code"></input>
              </div>
            </div>
          </div>
        </div>
        {/* KYC */}
        <div className="editWholesaler-subcontainer">
          <span className="edit-title">KYC</span>
        </div>
        <div className="general-container">
          <div className="general-left">
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>Driving License
              </label>

              <div>
                <input type="file" />
                <div>
                <span>
                  <input type="checkbox" />
                </span>
                <span className="textIsverified">Is Verified</span>
              </div>
              </div>
            </div>
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>PAN Card
              </label>

              <div>
                <input type="file"></input>
                <div>
                <span>
                  <input type="checkbox" />
                </span>
                <span className="textIsverified">Is Verified</span>
              </div>
              </div>
            </div>
          </div>
          <div className="general-right">
            <div className="editWholesaler-field">
              <label>
                <span className="text-danger">*</span>Aadhar Card
              </label>

              <div>
                <input type="file"></input>
                <div>
                <span>
                  <input type="checkbox" />
                </span>
                <span className="textIsverified">Is Verified</span>
              </div>
              </div>
            </div>
          </div>
        </div>
        {/* buttons*/}
        <div className="addbtnContainer">
          <div>
            <button className="admin-btnCancel">Cancel</button>
          </div>
          <div>
            <button className="add-btnSave">Update</button>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="editWholesaler-container">
      <div className="arrowNavigation">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/manage-ryder")}
        />
        <div>Venkatesh</div>
        <div>Ryder Id:#GMKD1234</div>
      </div>
      <div className="wholesalerMenu">
        <div
          onClick={() => {
            setContent(handlePersonalDetails);
            setactiveEdit("personal");
          }}
          className={`edit-menu ${
            activeEdit === "personal" ? "activeEdit" : ""
          }`}
        >
          Personal Details
        </div>
        <div
          onClick={() => {
            setContent(handleOrderHistory);
            setactiveEdit("orders");
          }}
          className={`edit-menu ${activeEdit === "orders" ? "activeEdit" : ""}`}
        >
          Orders History
        </div>
      </div>
      <div>{content}</div>
    </div>
  );
}
